import { inject, Injectable } from '@angular/core';
import { Router, UrlCreationOptions } from '@angular/router';

import { RuntimePage } from '@blaze-shared/elements-domain';
import { filterOutNullish } from '@blaze-shared/shared-util';

@Injectable({
  providedIn: 'root',
})
export class UrlPageSlugService {
  private readonly router = inject(Router);

  createPageSlugUrl(
    publishedUrl: string,
    runtimePage: RuntimePage,
    pageDataRowId: string | undefined,
    navigationExtras: UrlCreationOptions = {},
  ): string {
    const pageSlug = runtimePage.slug;
    const pathname = this.getUrlPathName(publishedUrl);

    return this.createRouteUrl(
      filterOutNullish([pathname, pageSlug, pageDataRowId]),
      navigationExtras,
    );
  }

  createRouteUrl(urlParams: string[], navigationExtras: UrlCreationOptions): string {
    return this.router.serializeUrl(this.router.createUrlTree(urlParams, navigationExtras));
  }

  private getUrlPathName(url: string): string {
    return decodeURIComponent((url ? new URL(url)?.pathname : window.location.pathname) || '');
  }
}
